import { StateCreator } from "zustand";
import type { AppSlice, FeatureFlags } from "../appStore.types";
import { defaultFeatureFlags } from "../appStore.types";

/**
 * Initial state for app slice.
 */
export const initialAppState = {
  isLoading: false,
  isHydrated: false,
  featureFlags: defaultFeatureFlags,
  alertMessage: undefined as string | undefined,
};

/**
 * Creates the app slice for Zustand store.
 * Handles app lifecycle state and feature flags.
 *
 * @example
 * ```typescript
 * const useStore = create<AppSlice>()(
 *   (...a) => ({
 *     ...createAppSlice(...a),
 *   })
 * );
 * ```
 */
export const createAppSlice: StateCreator<AppSlice, [], [], AppSlice> = (
  set
) => ({
  ...initialAppState,

  setLoading: (isLoading) => set({ isLoading }),

  setHydrated: (isHydrated) => set({ isHydrated }),

  setFeatureFlag: (flag: keyof FeatureFlags, value: boolean) =>
    set((state) => ({
      featureFlags: {
        ...state.featureFlags,
        [flag]: value,
      },
    })),

  setAlertMessage: (alertMessage) => set({ alertMessage }),

  reset: () =>
    set({
      isLoading: false,
      isHydrated: false,
      featureFlags: defaultFeatureFlags,
      alertMessage: undefined,
    }),
});

